import React from 'react';

/**
 * LegacyPage — wraps an un-migrated page that is mounted inside the new
 * shell. `.ui-legacy` opts its subtree out of the ui.css reset, so the page
 * keeps exactly the look it had before (its own MUI / Bootstrap styles).
 *
 * When a page unit ships the redesigned page, App.js swaps
 *   <LegacyPage><OldPage /></LegacyPage>   →   <NewPage />
 * and the old one stays reachable under /profile/legacy/… (see LegacyMount).
 */
export default function LegacyPage({ children }) {
  return <div className="ui-legacy">{children}</div>;
}
